import useSWR from 'swr'
import { getInboxUnread } from '../api/middleware/ytel/getInboxUnread'

export function useInboxUnread(
  email: string,
  options?: { refreshInterval?: number },
) {
  const { refreshInterval = 15000 } = options || {}

  const { data, error, isLoading, mutate } = useSWR<number>(
    ['inbox-unread', email],
    async () => {
      // Uncomment to test with random unread counts for dev
      // if (
      //   import.meta.env.MODE === 'development' ||
      //   window.location.hostname === 'agents-staging.turbodebt.com'
      // ) {
      //   return Math.floor(Math.random() * 20) // 0..19
      // }
      return getInboxUnread(email)
    },
    {
      refreshInterval,
      revalidateOnFocus: true,
      shouldRetryOnError: false,
    },
  )

  return {
    unreadCount: data ?? 0,
    isLoading,
    error,
    mutate,
  }
}
